angular.module("digitalLeasing.module").component("vendorTable", {
  templateUrl: "ng/components/digitalLeasing/vendorSelection/vendorTable/vendorTable.view.html",
  bindings: {
    list: "<",
    containerClass: "@",
    onVendorSelected: "&?",
    callNextStep:"&"
  },
  controllerAs: "vendorTableCtrl",
  controller: VendorTableCtrl
});

function VendorTableCtrl(
  RiUserG,
  $rootScope) {
  var self = this;

  self.$onInit = function () {
    self.$rootScope =$rootScope;
    if (self.list && self.list.length == 1) {
      self.select(0);
    }
    console.info("selected is:", self.selected);
  };

  self.isRowSelected = function (index) {
    if (self.selected && self.list[index].riUserG.ndg == self.selected.ndg) {
      return true;
    }
    return false;
  };

  self.select = function (index) {
    self.selected = self.list[index].riUserG;
    self.onVendorSelected({
      vendor: RiUserG.build(self.selected)
    });
    console.log("RIUSERG: ", self.selected);
  };

  self.doubleClick = function(index){
    self.$rootScope.disableDoubleClick= true;
    self.callNextStep();
  }
}